import { Formik } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import * as Yup from 'yup';
import TrusteeForm from './TrusteeForm';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import NextPageButton from 'react/shared/components/true_link/lab/form/wizard/NextPageButton';
import WizardCard from 'react/signups/card/common/WizardCard';
import trusteeDataShape from 'react/signups/card/shapes/TrusteeData';

export default function Trustee({
  cardholderFirstName,
  moduleComplete,
  setTrusteeData,
  trusteeData,
}) {
  const validationSchema = Yup.object().shape({
    trustee: Yup.string().required('Please select one of the options'),
  });

  const handleContinue = (values) => setTrusteeData({ trustee: values.trustee });

  return (
    <>
      <WizardCard>
        <>
          <CardHeader>
            Will {cardholderFirstName} use this card to spend funds from a Special Needs Trust?
          </CardHeader>
          <CardText>
            A special needs trust is a specific legal arrangement. If you select "Yes", we can
            provide a specific type of card for this situation.
          </CardText>
        </>
        <Formik
          initialValues={trusteeData}
          onSubmit={handleContinue}
          validationSchema={validationSchema}
        >
          {({ handleSubmit, values, handleChange }) => (
            <>
              <TrusteeForm
                cardholderFirstName={cardholderFirstName}
                onChange={handleChange}
                values={values}
              />
              <NextPageButton disabled={moduleComplete} id="cta-snt" onClick={handleSubmit} />
            </>
          )}
        </Formik>
      </WizardCard>
    </>
  );
}

Trustee.propTypes = {
  cardholderFirstName: PropTypes.string.isRequired,
  moduleComplete: PropTypes.bool.isRequired,
  setTrusteeData: PropTypes.func.isRequired,
  trusteeData: trusteeDataShape.isRequired,
};
